<template>
    <div id="appearance" class="wrapper">

        <section v-if="settings">
            <h2>Mobile appearance</h2>
            <p>These colors define how the messenger looks when you are using the android and iOS libraries</p>

            <general class="section" :settings="settings" ref="generalSettings"/>

            <mobile class="section" :settings="settings" ref="mobileSettings"/>

            <ios class="section" :settings="settings" ref="iosSettings"/>

            <button class="primary" v-on:click="checkDesignSettings">Save</button>
        </section>

        <p v-if="!settings && showLoading">
            Loading design settings...
        </p>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import general from './appearanceGeneral';
import ios from './appearanceIOS';
import mobile from './appearanceMobile';
import templateCss from './partials/templateCss.txt';

export default {
    name: 'appearance',
    mixins: [
        Default
    ],
    inject: {
        $validator: '$validator'
    },
    components: {
        ios,
        general,
        mobile
    },
    data() {
        return {
            platform: 'ios',
            settings: null,
            showLoading: false
        };
    },
    created: function() {
        // Only show loading when it takes longer than X ms
        window.setTimeout(() => {
            this.showLoading = true;
        }, 500);

        this.$http.get('v1.1/design').then(response => {
            let settings = response.data.data;

            // Parse null settings
            Object.keys(settings).map((settingKey) => {
                if (settings[settingKey] === null)
                    settings[settingKey] = '';
            });

            this.settings = settings;
        }, () => {
            // Error callback
        });
    },
    methods: {
        getDesignSettingsErrors: function() {
            let colorDesignSettings = [];
            // First value: keyValue
            // Second value: error message
            colorDesignSettings.push(['accountBackgroundColor', 'Account Background Color is empty']);
            colorDesignSettings.push(['accountTextColor', 'Account Text Color is empty']);
            colorDesignSettings.push(['accountTimeColor', 'Account Time Color Color is empty']);
            colorDesignSettings.push(['backgroundColor', 'Background Color Color is empty']);
            colorDesignSettings.push(['buttonLabelBackgroundColor', 'Button Label Background Color Color is empty']);
            colorDesignSettings.push(['buttonLabelTextColor', 'button Label Text Color Color is empty']);
            colorDesignSettings.push(['dateColor', 'Date Color Color is empty']);
            colorDesignSettings.push(['infoTextColor', 'Info Text Color Color is empty']);
            colorDesignSettings.push(['messengerIconBackgroundColor', 'Messenger Icon Background Color Color is empty']);
            colorDesignSettings.push(['navBackgroundColor', 'Nav Background Color Color is empty']);
            colorDesignSettings.push(['navTextColor', 'Nav Text Color Color is empty']);
            colorDesignSettings.push(['userBackgroundColor', 'User Background Color Color is empty']);
            colorDesignSettings.push(['userTextColor', 'User Text Color Color is empty']);
            colorDesignSettings.push(['userTimeColor', 'User Time Color is empty']);
            colorDesignSettings.push(['infoTextBackgroundColor', 'Info Text Background Color is empty']);
            colorDesignSettings.push(['iOSInputContainerBackgroundColor', 'iOS Input Container Background Color is empty']);
            colorDesignSettings.push(['iOSStatusBarTextColor', 'iOS Status Bar Text Color Color is empty']);
            return colorDesignSettings;
        },
        checkDesignSettings: function() {
            let colorDesignSettings = this.getDesignSettingsErrors();
            let anyError = false;

            // Custom error messages
            colorDesignSettings.forEach((item) => {
                // Use toString because iOSStatusBarTextColor is an int if not edited. The .length wont work then.
                if (!this.settings[item[0]].toString().length > 0)
                    [this.$refs.generalSettings, this.$refs.mobileSettings, this.$refs.iosSettings].forEach(group => {
                        if (!group.$refs[item[0]])
                            return;

                        group.$refs[item[0]].$validator.errors.add({
                            field: item[0],
                            msg: item[1]
                        });
                        anyError = true;
                    });
            });

            if (anyError === true)
                return;

            this.saveDesignSettings();
        },
        saveDesignSettings: function() {
            // Settings with a hex value gets a # set in the custom-component.
            // But the # value should be removed ones it gets saved. So slice it off!
            /* eslint-disable */
                this.$http.put('v1.1/design', {
                    accountBackgroundColor:             this.settings.accountBackgroundColor.slice(1),
                    accountTextColor:                   this.settings.accountTextColor.slice(1),
                    accountTimeColor:                   this.settings.accountTimeColor.slice(1),
                    backgroundColor:                    this.settings.backgroundColor.slice(1),
                    buttonLabelBackgroundColor:         this.settings.buttonLabelBackgroundColor.slice(1),
                    buttonLabelTextColor:               this.settings.buttonLabelTextColor.slice(1),
                    dateColor:                          this.settings.dateColor.slice(1),
                    infoTextColor:                      this.settings.infoTextColor.slice(1),
                    messengerIconBackgroundColor:       this.settings.messengerIconBackgroundColor.slice(1),
                    navBackgroundColor:                 this.settings.navBackgroundColor.slice(1),
                    navTextColor:                       this.settings.navTextColor.slice(1),
                    userBackgroundColor:                this.settings.userBackgroundColor.slice(1),
                    userTextColor:                      this.settings.userTextColor.slice(1),
                    userTimeColor:                      this.settings.userTimeColor.slice(1),
                    infoTextBackgroundColor:            this.settings.infoTextBackgroundColor.slice(1),
                    iOSInputContainerBackgroundColor:   this.settings.iOSInputContainerBackgroundColor.slice(1),
                    iOSStatusBarTextColor:              this.settings.iOSStatusBarTextColor,
                    inputFieldBackgroundColor:          this.settings.inputFieldBackgroundColor.slice(1),
                    inputFieldTextColor:                this.settings.inputFieldTextColor.slice(1),
                    inputFieldPlaceHolderColor:         this.settings.inputFieldPlaceHolderColor.slice(1),
                    inputBackgroundColor:               this.settings.inputBackgroundColor.slice(1),
                    inputTextColor:                     this.settings.inputTextColor.slice(1),
                    userTextLinkColor:                  this.settings.userTextLinkColor.slice(1),
                    userSentColor:                      this.settings.userSentColor.slice(1),
                    accountTextLinkColor:               this.settings.accountTextLinkColor.slice(1),
                    /* eslint-enable */
            }).then(() => {
                // Success callback
                this.$parleyAdmin.queryErrors.addError('Settings saved', this.$parleyAdmin.queryErrors.TYPE_SUCCESS);
            }, () => {
                // Error callback
                this.$parleyAdmin.queryErrors.addError('Error occurred when trying to save');
            });
        },
        generateFile: function(settings) {
            let file = templateCss; // The file is now parsed to a a string

            for (let key in settings) {
                // Skip loop if the property is from prototype
                if (!settings.hasOwnProperty(key)) continue;

                if (typeof settings[key] !== 'undefined' && settings[key] !== null)
                    if (settings[key].length > 0) {
                        let includeSubString = true; // Define for while loop to search again for the current key value
                        while (includeSubString === true)
                            if (file.includes('/*PLACEHOLDER_' + key.toString() + '*/'))
                                file = file.replace('/*PLACEHOLDER_' + key.toString() + '*/', settings[key] + '/* THIS_IS_GENERATED */');
                            else
                                includeSubString = false;
                    }
            }

            this.download('generatedFile.css', file);
        },
        download: function(filename, text) {
            const element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    #appearance {
        p {
            margin-bottom: 1em;
        }

        section {
            button.primary {
                margin: 0;
            }
        }

        .wrapper {
            overflow: visible; // Important, otherwise color pickers are hidden behind sections
        }

        .wrapper.section > section {
            margin-bottom: 1em;

            .custom-input {
                padding: 0 0 1em 0;
            }

            h4 {
                padding: 0;
            }

            .row {
                .custom-input.colorPicker:last-child {
                    margin-right: 0;
                }
            }
        }

        .wrapper.section:last-child > section:nth-last-child(1) {
            border-bottom: 0;
            margin-bottom: 25px;
        }

        /* Remove the option to choose Alpha (we do not support alpha in our colors) */
        .custom-input.colorPicker {
            .vc-chrome-alpha-wrap {
                display: none;
            }

            .vc-chrome-hue-wrap {
                top: 0.5em;
            }
        }
    }

    .v-popover {
        cursor: pointer;
        height: 1em;
        margin-right: 2em;
    }
</style>
